import React = require('react');

interface IPlacesProps {
    items:Array<IItem>
    itemChangeHandler:Function
    viewMode:boolean
}

export interface IItem{
	fromDate:string
	toDate:string
	city:string
}

export interface IPlacesState {
}

export class Places extends React.Component<IPlacesProps, IPlacesState>{

  	constructor(props:IPlacesProps){
        super(props);
    }

    private getEmpty():IItem{
        return {
            fromDate: '',
            toDate: '',
            city: ''
        };
    }

	private addNewRowHandler(evt): void {
		evt.preventDefault();
		var items = this.props.items;
		var newItem:IItem = this.getEmpty();
		if (  items.indexOf(newItem) === -1 ) {
			items.push(newItem);
			this.props.itemChangeHandler(items);
		}
	}

	private itemChangeHandler(evt, item:IItem, field:string): void {
		evt.preventDefault();
		var items = this.props.items;
		var currentIndex:number = items.indexOf(item);
		items[currentIndex][field] = evt.target.value;
		this.props.itemChangeHandler(items);
	}

    render() {
        return (
            <div className="moreItems">
				<div className="list">
					{
						this.props.items.map((item:IItem, key) => {
                            if (this.props.viewMode === true) {
                                return <div key={key}>
                                   { item.fromDate } - { item.toDate } <span className="ml10">{ item.city }</span>
                                </div>
                            }
							return <div className="row col3" key={key}>
								<div className="box">
									<input type="text" value={ item.fromDate } placeholder="dátum tól" onChange={ e => this.itemChangeHandler(e, item, 'fromDate') } />
								</div>
								<div className="box p5">
									<input type="text" value={ item.toDate } placeholder="dátum ig" onChange={ e => this.itemChangeHandler(e, item, 'toDate') } />
								</div>
								<div className="box p5">
									<input type="text" value={ item.city } placeholder="Város" onChange={ e => this.itemChangeHandler(e, item, 'city') } />
								</div>
							</div>
						})
					}
				</div>
                { this.props.viewMode === false?<div className="row col3">
					<div className="box"></div>
					<div className="box"></div>
					<div className="box right">
						<button className="btn addBtn" onClick={ e => this.addNewRowHandler(e) }> + Új sor</button>
					</div>
				</div>:'' }
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/edit_item/Places.tsx